import PresentationReducerBuilder from "./build-presentation-reducer"
import {
    DASHBOARD_KNOWLEDGE_SEARCH_REQUEST as LIST_SEARCH_REQUEST,
    DASHBOARD_KNOWLEDGE_PAGE_REQUEST as LIST_PAGE_REQUEST,
    DASHBOARD_KNOWLEDGE_RESPONSE as LIST_RESPONSE,
    DASHBOARD_INFO_ERROR_RESPONSE
} from "../../actions/action-types"
import {
    FeedFilterModel,
    updateFeedSearchFilterModel
} from "../../models/filters/feed-filter"

const reducerBuilder = new PresentationReducerBuilder()
const defaultReducer = reducerBuilder
    .actionsToHandle({
        LIST_PAGE_REQUEST,
        LIST_SEARCH_REQUEST,
        LIST_RESPONSE
    })
    .workingFilterModelClass(FeedFilterModel)
    .updateSearchFilterModel(updateFeedSearchFilterModel)
    .defaultState({
        searchCriteria: "title=",
        workingFilterModel: new FeedFilterModel()
    })
    .build()

export default (state = undefined, action) => {
    const newDefaultState = defaultReducer(state, action)
    const { type, error } = action
    switch (type) {
        case DASHBOARD_INFO_ERROR_RESPONSE:
            return {
                ...newDefaultState,
                error: error ? "Error Message" : null
            }
        default:
            return newDefaultState
    }
}
